// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.inputcpfcnpj {
    display: flex;
}
.inputcpfcnpj-button {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    flex-shrink: 0;
}
.inputcpfcnpj-hasbutton input {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
}
.inputcpfcnpj-haslabel input {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
}
.inputcpfcnpj-label {
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    background: #f3f4f6;
    color: #6b7280;
    border: 1px solid #d1d5db;
    border-right: 0;
    padding:0.75rem;
    min-width: 3rem;
}
.inputcpfcnpj-label>div {
    display: flex;
    align-items: center;
    justify-content: center;
}
.inputcpfcnpj-input {
    flex-grow: 1;
}
.inputcpfcnpj-input input {
    height: 100%;
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/styles/pages/components/InputCpfCnpj.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;AACA;IACI,4BAA4B;IAC5B,yBAAyB;IACzB,cAAc;AAClB;AACA;IACI,6BAA6B;IAC7B,0BAA0B;AAC9B;AACA;IACI,4BAA4B;IAC5B,yBAAyB;AAC7B;AACA;IACI,2BAA2B;IAC3B,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,eAAe;IACf,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;IACZ,WAAW;AACf","sourcesContent":[".inputcpfcnpj {\n    display: flex;\n}\n.inputcpfcnpj-button {\n    border-bottom-left-radius: 0;\n    border-top-left-radius: 0;\n    flex-shrink: 0;\n}\n.inputcpfcnpj-hasbutton input {\n    border-bottom-right-radius: 0;\n    border-top-right-radius: 0;\n}\n.inputcpfcnpj-haslabel input {\n    border-bottom-left-radius: 0;\n    border-top-left-radius: 0;\n}\n.inputcpfcnpj-label {\n    border-top-left-radius: 6px;\n    border-bottom-left-radius: 6px;\n    background: #f3f4f6;\n    color: #6b7280;\n    border: 1px solid #d1d5db;\n    border-right: 0;\n    padding:0.75rem;\n    min-width: 3rem;\n}\n.inputcpfcnpj-label>div {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.inputcpfcnpj-input {\n    flex-grow: 1;\n}\n.inputcpfcnpj-input input {\n    height: 100%;\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
